import { useRef } from "react";
import styles from "./DropdownFilter.module.scss";

export default function DropdownFilter({ title, options: optionsProp, name, defaultOptions, ...props }: any) {
  const defaultOptionsRef = useRef(defaultOptions || []);
  const options = (defaultOptions ? defaultOptionsRef.current : optionsProp) || [];

  return (
    <>
      {!!options.length && (
        <div style={{ position: "relative", display: "flex", flexDirection: "row" }}>
          <select {...props} name={name} className={styles.selectFilter} id={`filter-${name}`}>
            <option value="" selected>
              {title}
            </option>
            {options.map((item: any, index: any) => (
              <option key={index} value={item.slug || item.name}>
                {` ${item.name} `}
              </option>
            ))}
          </select>
          <svg
            style={{ position: "absolute", pointerEvents: "none", top: "40%", right: "18px" }}
            width="12"
            height="11"
            viewBox="0 0 15 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.918 2L7.95922 7.95875L2.00047 2"
              stroke="#1E9E81"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
        </div>
      )}
    </>
  );
}
